import config from 'emun.on-demand/templates/_config' 
import labels from 'emun.on-demand/templates/_labels' 
import resolve from 'ioc/resolve'
import ServiceBus from 'servicestack/service-bus'
import basicController from 'servicestack/basic.controller.properties'
import templateUrl from 'emun.on-demand/templates/od-product-template-fieldset.htm'
import modals from 'webmodals/modals'

class ProductTemplateFieldsetController {
    constructor() {
        basicController(this)
        const $ctrl = this;
        Object.assign($ctrl, {config, labels});
    }

    $onInit() {
        this.message = 'Loading Tags';
        ServiceBus.read('QueryProductTemplateTagKinds.json').then(res => {
            console.debug('QueryProductTemplateTagKinds', res);
            res.data.results.forEach(r => this.addTagKind(r.tagKind));
            this.message = false;
        });
    }

    addTagKindPrompt() {
        modals.prompt('Add Tag Kind...')
            .result
            .then(tk => this.addTagKind(tk));
    }

    addTagKind(tk) {
        if (!this.request)
            this.request = {};
        if (!this.request.tags)
            this.request.tags = {};
        if (!this.request.tags[tk])
            this.request.tags[tk] = [];
    }
}

let ProductTemplateFieldsetComponent = {
    bindings: {
        request: '<productTemplate',
        type: '@'
    },
    controller: ProductTemplateFieldsetController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl;
    }
}

export default ProductTemplateFieldsetComponent;